<template>
  <div>

    <z-container bottom="0" style="margin-top: -80px;">
      <v-toolbar dense flat style="background-color: rgb(255, 255, 255, 0);">
        <v-spacer></v-spacer>
          <v-btn icon @click="refresh" :loading="refreshing">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
      </v-toolbar>
    </z-container>
    
    <v-scroll-y-transition>
      <z-container v-if="!loading">


        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3" v-if="!config.DASHBOARD_RESUMIDO || $auth.isAdmin()">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Vendas mês anterior
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.vendasMesAnterior | valorBR(0) }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Vendas no mês
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.vendasMes }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Vendas de Hoje
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.vendas_do_dia }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Produtos Vendidos Mês
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.produtosVendidosMes }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Produtos Cadastrados
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.produtos_cadastrados | valorBR(0) }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" v-if="!config.DASHBOARD_RESUMIDO || $auth.isAdmin()">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Clientes Cadastrados
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.clientes }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" v-if="!config.DASHBOARD_RESUMIDO || $auth.isAdmin()">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Clientes Recentes
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.clientes_recentes }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" v-if="!config.DASHBOARD_RESUMIDO || $auth.isAdmin()">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Contas a Receber Geral
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.contas_receber }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" v-if="!config.DASHBOARD_RESUMIDO || $auth.isAdmin()">
            <v-card class="rounded-xl">
              <v-card-text class="text-center">
                <h4 class="text-overline">
                  Contas a Receber Mês
                </h4>
                <h3 class="text-h3">
                  {{ dashboard.contas_receber_mes }}
                </h3>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" :sm="$auth.isAdmin() ? 6 : 12">
            <grafico-vendas-semanal></grafico-vendas-semanal>
          </v-col>
          <v-col cols="12" sm="6" v-if="$auth.isAdmin()">
            <grafico-vendas-mensal></grafico-vendas-mensal>
          </v-col>
          <v-col cols="12" sm="12" v-if="$auth.isAdmin()">
            <grafico-vendas-anual></grafico-vendas-anual>
          </v-col>
        </v-row>
        
      </z-container>
    </v-scroll-y-transition>
  </div>

</template>

<script>
import config from '@/app/config';
import BarChart from "@/components/graficos/BarChart";
import { range } from "@/app/helpers/utils";

import GraficoVendasSemanal from './GraficoVendasSemanal';
import GraficoVendasMensal from './GraficoVendasMensal';
import GraficoVendasAnual from './GraficoVendasAnual';

export default {
  name: 'Dashboard',

  components: {
    BarChart,
    GraficoVendasSemanal,
    GraficoVendasMensal,
    GraficoVendasAnual,
  },

  data: () => ({
    loading: false,
    refreshing: false,
    show: true,
    current_year: new Date().getFullYear(),
    current_month: new Date().getMonth() + 1,
  }),

  computed: {
    anos() {
      return range(new Date().getFullYear(), 2018);
    },
    temDoisDiasVenda() {
      return this.dashboard.vendas_da_semana.series[0].data.length >= 2;
    },

    dashboard() {
      return this.$store.state.dashboard.dashboard;
    },

    config() {
      return this.$store.state.configuracoes;
    },
  },

  async created () {
    this.loading = false;
    await this.getDashboard();
  },

  methods: {

    async getDashboard() {
      try {
        if (!this.refreshing)
          this.loading = true;

        const response = await this.$axios.get('/dashboard');
        this.$store.commit('dashboard/SET_DASHBOARD', response.data)
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },

    async refresh() {
      this.refreshing = true;
      await this.getDashboard();
    },
  },
};
</script>

<style>
  .sublinhado {
    text-decoration: underline;
  }
</style>